"use strict";

define('rs/validation/report.validation',['e3-common', 'evisions/validation'], function (E3Common, Validation) {
  var ReportValidation = E3Common.ValidationObj.extend({
    validators: {
      'name': [Validation.empty(), Validation.checkLength(0, 50)],
      'columns': ['emptyColumns']
    },
    getColumnsFieldValue: function getColumnsFieldValue(el) {
      return el.find('.list-group').children().length;
    },
    emptyColumns: function emptyColumns(columns) {
      if (!columns) {
        return 'You must specify the report columns by dragging them from the available columns lists.';
      }
      return true;
    }
  }, {
    validate: function validate() {
      return new Promise(function (resolve, reject) {
        if (ReportValidation.get().validate()) {
          resolve();
        } else {
          reject(new Error('Validate Error'));
        }
      });
    }
  });
  return ReportValidation;
});

